import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MypageCommonDialogComponent } from 'src/app/components/mypage/mypage-common-dialog/mypage-common-dialog.component';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private authService: AuthService,
    private matDialog: MatDialog
  ) { }

  user: User
  ngOnInit(): void {
    this.user = this.commonService.getUserInfo()
  }
  openMypageCommonPopup(type: string) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.disableClose = false
    dialogConfig.id = "mypageCommonWindow"
    //dialogConfig.width = "640px"
    //dialogConfig.height = "600px"
    dialogConfig.data = {
        userNo: this.user.userNo
      , type: type
      , user: this.user
    }
    const matDialog = this.matDialog.open(MypageCommonDialogComponent, dialogConfig);
    matDialog.afterClosed().subscribe(res => {
      //none
    })
  }
  logout(){
    this.authService.logout()
  }

  openGuideWindow() {
    var width = 1400 //screen.availWidth - 150
    var height = 800 //screen.availHeight - 250
    var windowPopup = window.open('/guide', 'guideWindow', 'width='+width/13*11+',height='+height+',left='+width/13*4+',top=0,scrollbars=no');
    windowPopup.focus();
  }
}
